import { css } from "@emotion/react";
import { MEDIA_QUERY_FOR_PC } from "constants/mediaQueryForPc";
import { MEDIA_QUERY_FOR_SP } from "constants/mediaQueryForSp";

export const contentsWrapperStyle = css`
  display: grid;

  ${MEDIA_QUERY_FOR_PC} {
    padding-block: 56px;
    row-gap: 40px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    padding-block: 12px;
    row-gap: 24px;
  }
`;
